import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`

let api = {
  // 查询宣传视频
  getYqVideoPage: `${baseUrl}/video/getPage`,

  // 添加宣传视频
  addyqVideo: `${baseUrl}/video/add`,

  // 添加视频url
  addNew: `${baseUrl}/video/addNew`,

  // 查询宣传视频
  getYqVideoByCode: `${baseUrl}/video/getByCode`,

  // 修改宣传视频
  updateyqVideo: `${baseUrl}/video/update`,

  // 删除宣传视频
  deleteyqVideoByCodes: `${baseUrl}/video/deleteByCodes`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/yqVideo.js